"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorForNode = void 0;
const memoize_weak_1 = __importDefault(require("memoize-weak"));
const lodash_1 = require("lodash");
const toolbox_redux_framework_1 = require("@zapier/toolbox-redux-framework");
exports.getErrorForNode = memoize_weak_1.default((taskState, nodeId) => {
    if (!taskState.breadcrumbs) {
        return undefined;
    }
    const lastNodeBreadcrumb = lodash_1.findLast(taskState.breadcrumbs, ({ object_id }) => object_id === nodeId);
    if (!lastNodeBreadcrumb) {
        return undefined;
    }
    const bundle = lastNodeBreadcrumb.error_bundle ||
        (lastNodeBreadcrumb.error && {
            title: lastNodeBreadcrumb.error,
        });
    if (!bundle) {
        return undefined;
    }
    return new toolbox_redux_framework_1.commonErrors.SampleError(Object.assign(Object.assign({}, bundle), { step: lastNodeBreadcrumb.step }));
});
exports.default = exports.getErrorForNode;
